export enum OtClickPeriods {
	TradePeriod = "TradePeriod",
	Month = "Month",
	Quarter = "Quarter",
	CalYear = "CalYear",
}

interface PaginationType {
	total_elements: number;
	page: number;
	pages: number;
	per_page: number;
}

export interface GenericReferential {
	id: string;
	name: string;
}

export interface ContactType {
	email: string;
	id: number;
	name: string;
	recipient_types: string[];
}

export interface GetContactsResponseType {
	pagination: {
		page: number;
		pages: number;
		per_page: number;
		total_elements: number;
	};
	result: ContactType[];
}

export interface BcvConfigDataType {
	id: number;
	name: string;
}

export interface GetBCVConfigResponseType {
	id: number;
	name: string;
	bcv_config_data: BcvConfigDataType[];
}

export interface CertificatesTypesResponseType extends GenericReferential {}

export interface ClickTypesResponseType extends GenericReferential {
	ot_name: OtClickPeriods;
}

export interface PriceIndex extends GenericReferential {
	orchestrade_id: number;
}

export interface BookType extends GenericReferential {
	portfolio_prefix: string;
}

export interface ServicePoint {
	id: number;
	name: string;
	code: string | null | undefined;
	tso_id: number;
}

export interface ServicePointsResponseType {
	pagination: PaginationType;
	result: ServicePoint[];
}
export interface Tso extends GenericReferential {}

export interface Books extends GenericReferential {}

export interface DynamicEndpointQuery {
	endpoint?: string;
}

export const ClickPeriodFrequencyLabels: { [key: string]: string } = {
	MONTHLY: "MONTHLY",
	QUARTERLY: "QUARTERLY",
	YEARLY: "YEARLY",
	DEFAULT: "Default",
};
export interface ContractPeriod {
	start_date: string;
	id: number;
	end_date: string;
	contractId: number;
	contractName: string;
}

export interface FieldDataDefQuery {
	query_name: string;
	definition: string;
	sub_query: string;
	serviceprovider_name?: string;
	unit?: string;
	step?: string;
	fielddata_type: {
		id: number;
		name: string;
	};
	fielddata_kind: {
		id: number;
		name: string;
	};
	fielddata_maturity: {
		id: number;
		name: string;
	};
	fielddata_variant: {
		id: number;
		name: string;
	};
	fielddata_id: number;
}
